import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
// import { Button } from 'reactstrap';

import * as moment from 'moment';
// import 'moment-timezone';



export default class MiladiDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miladistartdate: null,
            miladiendate: null,
            miladifocusedInput: null,

        }

        moment.locale('en')

    }

    render() {
        let newdate = new Date();
        let today = moment(newdate).format("YYYY-MM-DD");
        return (
            <div className="w-100 pt-5 pb-5  calender-jalali">
                <div  >
                    <DateRangePicker
                        startDateId='miladistartdate'
                        endDateId='miladiendate'
                        startDate={this.state.miladistartdate} // momentPropTypes.momentObj or null,
                        endDate={this.state.miladiendate} // momentPropTypes.momentObj or null,
                        onDatesChange={({ startDate, endDate }) => this.setState({ miladistartdate: startDate, miladiendate: endDate })} // PropTypes.func.isRequired,
                        focusedInput={this.state.miladifocusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={focusedInput => this.setState({ miladifocusedInput: focusedInput })} // PropTypes.func.isRequired,
                        // isRTL={false}
                        startDatePlaceholderText="Arrival"
                        endDatePlaceholderText="Return"
                        // renderMonthText={month => moment(month).format('MMMM YYYY')}
                        // renderDayContents={day => moment(day).format('D')}
                        displayFormat={'YYYY-MM-DD'}
                        customArrowIcon={null}
                        hideKeyboardShortcutsPanel={true}
                    // keepOpenOnDateSelect={true}
                    />
                </div>
                {/* {console.log(this.state.miladifocusedInput)} */}
                {this.state.miladifocusedInput != null &&
                    <div className='Today-date-change'>
                        <span className='date-of-today'>
                            Today : <span>{today}</span>
                        </span>
                        {/* <span className='change-to-persian'>
                            <Button color="secondary" onClick={() => {
                                console.log('555')
                                // this.props.set();
                            }} >Persian Calender</Button>
                        </span> */}
                    </div>
                }

            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/Calendar/MiladiDate.jsx